// Dependencies
import React, { Component } from 'react';
import { Document, Page, pdfjs } from "react-pdf";

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Styling
import './frame.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Primereact
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

// Redux
import CmsService from '../../redux/services/cms';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class ExternalFramePage extends Component {

    constructor(props) {    
        super(props);
        this._toast = React.createRef();
        this.state = {
            numPages: null,
            pageNumber: 1,
            pdf: null
        };
    }

    componentDidMount() {
        CmsService.getRegimentoPageContent()
        .then((response) => {
            const byteCharacters = atob(response.fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            this.setState({
                pdf: new Blob([byteArray], {type: response.contentType})
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("content.regimento.messages.error"), life: 3000 });
        });
    }

    goToPrevPage() {
        if(this.state.pageNumber !== 1) {
            this.setState({pageNumber: this.state.pageNumber - 1});
        }
    }

    goToNextPage() {
        if(this.state.pageNumber !== this.state.numPages) {
            this.setState({pageNumber: this.state.pageNumber + 1});
        }
    }

    render() {
       return (
            <div className='grid mgb-80 mgt-20'>
                <div className='col-4'></div>
                <div className='col-1 t-align-left'>
                    <Button className='p-button-info' label={this.props.t("content.general.messages.previous")} onClick={() => this.goToPrevPage()} />
                </div>
                <div className='col-2 t-align-center'>
                    <p style={{marginTop:"10px"}}>{this.props.t("content.general.messages.page")} {this.state.pageNumber} {this.props.t("content.general.messages.from")} {this.state.numPages}</p>
                </div>
                <div className='col-1 t-align-right'>
                    <Button className='p-button-info' label={this.props.t("content.general.messages.next")} onClick={() => this.goToNextPage()} />
                </div>
                <div className='col-4'></div>
                <div className='col-4'></div>
                <div className='col-4'>
                    <Document
                        file={this.state.pdf}
                        onContextMenu={(e) => e.preventDefault()}
                        onLoadSuccess={({ numPages })=>this.setState({numPages: numPages})}
                        pageLayout="twoPageLeft"
                        pageMode="fullScreen"
                        className="pdf-container">
                            <Page pageNumber={this.state.pageNumber} />
                    </Document>
                </div>
                <div className='col-4'></div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
    }
}

export default authenticationChecker(withTranslation(ExternalFramePage));